import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useShoppingList } from '../../context/ShoppingListContext';
import Cart from '../../components/cart/Cart';
import Seo from '../../components/seo/Seo';

function CartPage() {
  const { shoppingList, setIsShoppingListOpen } = useShoppingList();
  const navigate = useNavigate();

  // Przekierowanie do strony głównej jeśli koszyk jest pusty
  useEffect(() => {
    if (shoppingList.length === 0) {
      navigate('/');
      setIsShoppingListOpen(true);
    }
  }, [shoppingList, navigate, setIsShoppingListOpen]);

  return (
    <>
      <Cart products={shoppingList} />;
      <Seo title={`Koszyk`}></Seo>
    </>
  );
}

export default CartPage;
